import { ReactElement, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";
import axios from "axios";
import connectorIcon from "../Images/ConnectorIcon.png";
import LoginAuth0 from "../pages/loginAuth0";
import LogoutAuth0 from "../pages/logoutAuth0";

interface NavBarProps {}

export function NavBar({}: NavBarProps): ReactElement {
  const { isAuthenticated, isLoading } = useAuth0();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkAuthStatus = () => {
      axios.get('/check-auth', { withCredentials: true })
        .then((response) => {
          const backendAuthenticated = response.data && response.data.authenticated === true;
          setIsLoggedIn(backendAuthenticated || isAuthenticated);
        })
        .catch((error) => {
          console.log("Auth check failed:", error);
          setIsLoggedIn(isAuthenticated);
        });
    };

    if (!isLoading) {
      checkAuthStatus();
    }
  }, [isAuthenticated, isLoading]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <nav>
      <div className="enliveLogoContainer">
        <Link to="/"> 
          <img src={connectorIcon} alt="Enlive Logo" className="enlive-logo-nav" />
        </Link> 
      </div>
      
      <div className="navBar navGlass moveRight">
        <div className="d-flex flex-column gap-1">
          {isLoggedIn ? (
            <>
              <LogoutAuth0 />
              <Link className="enlive-nav-link" to="/my-profile">My Profile</Link>
            </>
          ) : (
            <>
              <LoginAuth0 />
              <Link className="enlive-nav-link" to="/my-profile">My Profile</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

